// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy-wrapper {
	width: 100%;
	min-height: calc(100vh - 80px);
	background-color: var(--background);
	padding: 120px 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.privacy-policy {
	max-width: 960px;
	width: 100%;
	display: flex;
	flex-direction: column;
	font-size: 20px;
	font-weight: 400;
	color: var(--text);
	line-height: 24px;
	font-family: "Poppins", sans-serif !important;
	gap: 24px;
}

.privacy-policy__title {
	font-size: 48px;
	font-weight: 400;
	color: var(--dark);
	line-height: 48px;
	font-family: "Poppins", sans-serif;
	max-width: 500px;
	text-transform: uppercase;
	margin-bottom: 20px !important;
}

.privacy-policy__last-updated {
	margin-bottom: 20px !important;
}

.privacy-policy__bold-text {
	font-weight: 500;
}

.privacy-policy__list {
	padding-left: 1rem !important;
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.privacy-policy__list li {
	display: list-item;
	list-style: inside;
}

.privacy-policy__section-title {
	margin-top: 12px !important;
}

.privacy-policy p {
	font-size: 20px;
	font-weight: 400;
	color: var(--text);
	line-height: 24px;
	font-family: "Poppins", sans-serif !important;
}

.privacy-policy__link {
	font-size: 20px !important;
	font-weight: 400;
	color: var(--button) !important;
	font-family: "Poppins", sans-serif !important;
	line-height: 24px !important;
}

@media (max-width: 950px) {
	.privacy-policy-wrapper {
		width: 100%;
		min-height: calc(100vh - 70px);
		background-color: var(--background);
		padding: 40px 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.privacy-policy__title {
		font-size: 32px;
		font-weight: 400;
		color: var(--dark);
		line-height: 32px;
		font-family: "Poppins", sans-serif;
		max-width: 400px;
		text-transform: uppercase;
		margin-bottom: 16px !important;
	}

	.privacy-policy p {
		font-size: 16px;
		font-weight: 400;
		color: var(--text);
		line-height: 20px;
		font-family: "Poppins", sans-serif !important;
	}

	.privacy-policy__link {
		font-size: 16px !important;
		font-weight: 400;
		color: var(--button) !important;
		font-family: "Poppins", sans-serif !important;
		line-height: 20px !important;
		word-break: break-word;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/PrivacyPolicy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,8BAA8B;CAC9B,mCAAmC;CACnC,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,6CAA6C;CAC7C,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;CAChB,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,6CAA6C;AAC9C;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,+BAA+B;CAC/B,6CAA6C;CAC7C,4BAA4B;AAC7B;;AAEA;CACC;EACC,WAAW;EACX,8BAA8B;EAC9B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;CAC/B;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;CAC9C;;CAEA;EACC,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;EAC/B,6CAA6C;EAC7C,4BAA4B;EAC5B,sBAAsB;CACvB;AACD","sourcesContent":[".privacy-policy-wrapper {\n\twidth: 100%;\n\tmin-height: calc(100vh - 80px);\n\tbackground-color: var(--background);\n\tpadding: 120px 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.privacy-policy {\n\tmax-width: 960px;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tfont-size: 20px;\n\tfont-weight: 400;\n\tcolor: var(--text);\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tgap: 24px;\n}\n\n.privacy-policy__title {\n\tfont-size: 48px;\n\tfont-weight: 400;\n\tcolor: var(--dark);\n\tline-height: 48px;\n\tfont-family: \"Poppins\", sans-serif;\n\tmax-width: 500px;\n\ttext-transform: uppercase;\n\tmargin-bottom: 20px !important;\n}\n\n.privacy-policy__last-updated {\n\tmargin-bottom: 20px !important;\n}\n\n.privacy-policy__bold-text {\n\tfont-weight: 500;\n}\n\n.privacy-policy__list {\n\tpadding-left: 1rem !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 12px;\n}\n\n.privacy-policy__list li {\n\tdisplay: list-item;\n\tlist-style: inside;\n}\n\n.privacy-policy__section-title {\n\tmargin-top: 12px !important;\n}\n\n.privacy-policy p {\n\tfont-size: 20px;\n\tfont-weight: 400;\n\tcolor: var(--text);\n\tline-height: 24px;\n\tfont-family: \"Poppins\", sans-serif !important;\n}\n\n.privacy-policy__link {\n\tfont-size: 20px !important;\n\tfont-weight: 400;\n\tcolor: var(--button) !important;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tline-height: 24px !important;\n}\n\n@media (max-width: 950px) {\n\t.privacy-policy-wrapper {\n\t\twidth: 100%;\n\t\tmin-height: calc(100vh - 70px);\n\t\tbackground-color: var(--background);\n\t\tpadding: 40px 20px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n\n\t.privacy-policy__title {\n\t\tfont-size: 32px;\n\t\tfont-weight: 400;\n\t\tcolor: var(--dark);\n\t\tline-height: 32px;\n\t\tfont-family: \"Poppins\", sans-serif;\n\t\tmax-width: 400px;\n\t\ttext-transform: uppercase;\n\t\tmargin-bottom: 16px !important;\n\t}\n\n\t.privacy-policy p {\n\t\tfont-size: 16px;\n\t\tfont-weight: 400;\n\t\tcolor: var(--text);\n\t\tline-height: 20px;\n\t\tfont-family: \"Poppins\", sans-serif !important;\n\t}\n\n\t.privacy-policy__link {\n\t\tfont-size: 16px !important;\n\t\tfont-weight: 400;\n\t\tcolor: var(--button) !important;\n\t\tfont-family: \"Poppins\", sans-serif !important;\n\t\tline-height: 20px !important;\n\t\tword-break: break-word;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
